import React from 'react';
import ReactDOM from 'react-dom';
import 'roboto-npm-webfont/style.css';

import { BrowserRouter, Switch } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'; // v1.x
import { MuiThemeProvider as V0MuiThemeProvider } from 'material-ui';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import { unregister } from './registerServiceWorker';
import { AppWrapper } from './AppWrapper';

import './index.css';
import './tags.css';

const themeV0 = getMuiTheme({
	tooltip: {
		rippleBackgroundColor: '#542376',
	},
	palette: {
		primary1Color: '#542376',
	},
});

const theme = createMuiTheme({
	typography: {
		button: {
			textTransform: 'none',
		},
	},
	shape: {
		borderRadius: 0,
	},
	palette: {
		primary: {
			main: '#542376',
		},
	},
});

ReactDOM.render(
	<MuiThemeProvider theme={theme}>
		<V0MuiThemeProvider muiTheme={themeV0}>
			<BrowserRouter>
				<Switch>
					<AppWrapper />
				</Switch>
			</BrowserRouter>
		</V0MuiThemeProvider>
	</MuiThemeProvider>,
	document.getElementById('root'),
);

unregister();



// WEBPACK FOOTER //
// src/index.js